import { NgModule } from '@angular/core';

import { LocationService } from './services/location.service';

@NgModule({
    providers: [
        LocationService,
        {
            provide: 'Window',
            useValue: window,
        },
    ]
})

export class LocationModule {}
